//External
import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
import { useFormik } from "formik";
import { withRouter } from "next/router";
//Internal
import { sendContactUs } from "../../store/actions";

import { VALIDATIONS_ERROR_MESSAGES } from "../../utils/constants";
import { contactUsFormSchema, get_cookie, set_cookie } from "../../utils";
import { useRouter } from "next/router";
import { getUserInfo } from "store/actions/user";
import { ButtonLoader } from "components/loader/ButtonLoader";

// import Recaptcha from "./recaptcha";

const Recaptcha = dynamic(() => import("./recaptcha"), {
  ssr: false,
});
const TelInputFunctional = dynamic(() => import("components/phoneInput"), {
  ssr: false,
});
const Contactus = ({ currentLocationId }) => {
  const { userInfo } = useSelector(({ user }) => user);
  const userToken = useSelector((state1) => state1?.user);
  const dispatch = useDispatch();
  const router = useRouter();
  const is_mobile_app = get_cookie("is_mobile_app");

  const [disabledName, setDisabledName] = useState(false);
  const [isShowName, setIsShowName] = useState(true);
  const [disabledEmail, setDisabledEmail] = useState(false);
  const [isShowEmail, setIsShowEmail] = useState(true);

  const [isShowPhoneNumber, setIsShowPhoneNumber] = useState(true);
  const [successMsg, setsuccessMsg] = useState(false);
  const [value, setValue] = useState("");
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(true);
  const [numValidation, setNumValidation] = useState({
    valid: false,
    error: "",
  });
  const [loader, setLoader] = useState(false);
  const [isWeb, setIsWeb] = useState(true);
  const [recaptchaElement, setRecaptchaElement] = useState();
  const [ipAddress, setIpAddress] = useState();
  //use for get ip
  useEffect(async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const ipData = await response.json();
      setIpAddress(ipData?.ip);
    } catch (error) {
      console.error("Failed to get IP address:", error);
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      if (userInfo?.contact_number) {
        setNumValidation({
          valid: true,
          error: "",
        });
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (window.screen.width < 768) {
      setIsWeb(false);
    } else {
      setIsWeb(true);
    }
  }, []);

  /*******************
  @Purpose : used for Useformik payment value and validation
  @Parameter : {}
  @Author : INIC
  *******************/
  const formik = useFormik({
    initialValues: {
      firstName: userInfo?.first_name || "",
      email: userInfo?.email || "",
      contactNumber: userInfo?.contact_number || "",
      subject: "",
      message: "",
    },
    enableReinitialize: true,
    validationSchema: contactUsFormSchema,
    onSubmit: async (values1) => {
      setLoader(true);
      // Fetch the user's public IP address
      const data = {
        name: values1.firstName,
        email: values1.email,
        phone_number: values1.contactNumber,
        subject: values1.subject,
        message: values1.message,
        location_id: currentLocationId,
        country: values1.country_code,
        client_ip: ipAddress,
      };

      if (recaptchaElement.current.getValue()) {
        document.getElementById("gtContactUsSuccess").click();
        await dispatch(sendContactUs(data));
        setIsSuccessMessage(true);
        setLoader(false);
        grecaptcha.reset();
        formik.resetForm();
        setErrorMessage("");
        // setsuccessMsg(true);
        setNumValidation({
          valid: false,
          error: "",
        });

        // router.push("/contact-us-thank-you");
        set_cookie("contact-us-thank-you", "yes", 1);
        window.location.href = "/contact-us-thank-you";

        /*
        setTimeout(() => {
          setsuccessMsg(false);
        }, 5000);
        */
      } else {
        setErrorMessage("Please select the captcha", true);
        setLoader(false);
      }
    },
  });

  /*******************
  @Purpose : React Hook used for get user info
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    if (userToken?.token) {
      // Check if user is a guest (new user)
      const isGuest = get_cookie("is_guest") === "true";

      // Only call profile API for existing users (not guests)
      if (!isGuest) {
        dispatch(getUserInfo());
      }
    }
  }, []);

  /*******************
@Purpose : Formik Properties
@Parameter : {}
@Author : INIC
*******************/
  const { errors, handleSubmit, touched } = formik;

  /*******************
    @purpose : Phone input submit
    @Parameter : {val,country}
    @Author : INIC
    ******************/
  const handleInputChange = (val, country, isValid) => {
    setNumValidation({
      valid: isValid,
      error: "",
    });
    formik.setFieldValue("contactNumber", val);
    formik.setFieldValue("country_code", `+${country.dialCode}`);
  };

  /*******************
    @purpose : used for set all state
    @Parameter : {}
    @Author : INIC
   ******************/
  useEffect(() => {
    if (userInfo?.first_name && is_mobile_app !== "yes") {
      setDisabledName(true);
      if (window.screen.width < 993) {
        setIsShowName(false);
      }
    } else {
      setDisabledName("");
    }

    if (userInfo?.email && is_mobile_app !== "yes") {
      setDisabledEmail(true);
      if (window.screen.width < 993) {
        setIsShowEmail(false);
      }
    } else {
      setDisabledEmail("");
    }

    if (userInfo?.contact_number && is_mobile_app !== "yes") {
      setValue(userInfo?.contact_number ? `${userInfo?.contact_number}` : "");
      if (window.screen.width < 993) {
        setIsShowPhoneNumber(false);
      }
    } else {
      setValue("");
      // FCR-530: removed a delayed window.scrollTo(0, 0) here — it fired
      // 1s after mount and yanked the user back to the top on any page
      // embedding this form (e.g. CMS pages).
    }
  }, [userInfo]);

  /*******************
    @purpose : set recaptcha null
    @Parameter : {}
    @Author : INIC
   ******************/
  const setRecaptchMsg = () => {
    setErrorMessage("");
  };

  const onClickHandler = () => {};

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="get-in-touch">
        <h3 className="mb-0 ff-hel-med">Get in touch with us</h3>

        {/* Get in touch Form */}
        <Form className="contact-form" onSubmit={handleSubmit}>
          {isShowName && (
            <div className="input-field form-group">
              <div className="floating-form">
                <Form.Group
                  controlId="formFirstName"
                  className="floating-form-group error"
                >
                  <Form.Control
                    className={`${
                      formik?.touched["firstName"] &&
                      formik?.errors["firstName"] &&
                      "error"
                    }`}
                    formik={formik}
                    type="text"
                    placeholder="First name"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={(e) => {
                      formik.setFieldValue("firstName", e.target.value);
                    }}
                    disabled={disabledName}
                  />
                  <Form.Label className="floating-label p-0">
                    First Name*
                  </Form.Label>

                  {touched?.firstName && errors.firstName && (
                    <span className="text-danger text-error error-msg error-msg">
                      {errors.firstName}
                    </span>
                  )}
                </Form.Group>
              </div>
            </div>
          )}

          {isShowEmail && (
            <div className="input-field form-group">
              <div className="floating-form">
                <Form.Group
                  controlId="formEmail"
                  className="floating-form-group error"
                >
                  <Form.Control
                    className={`${
                      formik?.touched["email"] &&
                      formik?.errors["email"] &&
                      "error"
                    }`}
                    formik={formik}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formik.values.email}
                    onChange={(e) => {
                      formik.setFieldValue(
                        "email",
                        e.target.value?.toLowerCase()
                      );
                    }}
                    disabled={disabledEmail}
                  />
                  <Form.Label className="floating-label p-0">Email*</Form.Label>
                  {touched?.email && errors.email && (
                    <span className="text-danger text-error error-msg">
                      {errors.email}
                    </span>
                  )}
                </Form.Group>
              </div>
            </div>
          )}
          <div className="phone-group input-field  phone-boxwrap form-group">
            <div className="floating-form">
              <Form.Group
                controlId="phoneNumber"
                className="floating-form-group error inner-phone-number"
              >
                {isShowPhoneNumber && (
                  <div className="position-relative phone-form-control">
                    <TelInputFunctional
                      formik={formik}
                      fieldName="contactNumber"
                      className={`floating-input ${
                        formik?.touched["contactNumber"] &&
                        formik?.errors["contactNumber"] &&
                        "error"
                      }`}
                      name="contactNumber"
                      value={formik.values.contactNumber}
                      setValue={setValue}
                      handleInputChange={handleInputChange}
                      label={"Phone number*"}
                      country={
                        userInfo?.country_shortname?.sortname?.toLowerCase() &&
                        userInfo?.country_shortname?.sortname?.toLowerCase()
                      }
                      setNumValidation={setNumValidation}
                      disabled={userInfo?.contact_number_verified == 1}
                      contactPhoneNo="contactPhoneNo"
                    />
                  </div>
                )}
                {!numValidation.valid && touched?.contactNumber && (
                  <span
                    className={`error-msg d-inline-block ${
                      !numValidation.valid &&
                      errors?.contactNumber &&
                      numValidation.valid &&
                      "d-none"
                    }`}
                  >
                    {numValidation.error
                      ? numValidation.error
                      : errors?.contactNumber}
                  </span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="input-field form-group">
            <div className="floating-form">
              <Form.Group
                controlId="formSubject"
                className="floating-form-group error"
              >
                <Form.Control
                  formik={formik}
                  className={`${
                    formik?.touched["subject"] &&
                    formik?.errors["subject"] &&
                    "error"
                  }`}
                  type="text"
                  placeholder="Subject"
                  value={formik.values.subject}
                  name="subject"
                  onChange={(e) => {
                    formik.setFieldValue("subject", e.target.value);
                  }}
                />
                <Form.Label className="floating-label p-0">Subject*</Form.Label>
                {touched?.subject && errors.subject && (
                  <span className="text-danger text-error error-msg">
                    {errors.subject}
                  </span>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="input-field form-group">
            <div className="floating-form">
              <Form.Group
                controlId="exampleForm.ControlTextarea"
                className="floating-form-group error"
              >
                <Form.Control
                  formik={formik}
                  as="textarea"
                  className={`${
                    formik?.touched["message"] &&
                    formik?.errors["message"] &&
                    "error"
                  }`}
                  rows={4}
                  placeholder="Message"
                  value={formik.values.message}
                  name="message"
                  onChange={(e) => {
                    formik.setFieldValue("message", e.target.value);
                  }}
                />
                <Form.Label className="floating-label p-0">Message*</Form.Label>
                {touched?.message && errors.message && (
                  <span className="text-danger text-error error-msg">
                    {errors.message}
                  </span>
                )}
              </Form.Group>
            </div>
          </div>

          <Recaptcha
            setRecaptchMsg={setRecaptchMsg}
            setRecaptchaElement={setRecaptchaElement}
          />

          {errorMessage && (
            <span className="text-danger text-error">{errorMessage}</span>
          )}
          <div className="form-btn mb-0">
            {!errorMessage && isSuccessMessage && (
              <p className="mb-0 text-success ff-hel-med form-msg">
                {successMsg ? VALIDATIONS_ERROR_MESSAGES.GIT_SUCCESS : ""}
              </p>
            )}

            <Button
              variant="primary"
              type="submit"
              className={`w-100 d-flex align-items-center justify-content-center mt-0 gtStep1 ${
                loader ? "btn-loader-size-s" : ""
              }`}
              disabled={loader}
            >
              {loader ? <ButtonLoader /> : "Send"}
            </Button>
          </div>
          <input
            type="hidden"
            id="gtContactUsSuccess"
            name="gtContactUsSuccess"
            onClick={onClickHandler}
          />
        </Form>
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => ({
  userInfo: user.userInfo,
});
export default withRouter(connect(mapStateToProps)(Contactus));
